var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Actions, ofAction, Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { DriveState } from '../../state/drive-state';
import { take } from 'rxjs/operators';
import { BaseDialog } from 'common/core/ui/dialogs/base-dialog';
import { MoveEntries } from '../../state/actions/commands';
import { MoveEntriesFailed, MoveEntriesSuccess } from '../../state/actions/events';
import { ROOT_FOLDER } from '../../folders/root-folder';
var MoveEntriesDialogComponent = /** @class */ (function (_super) {
    __extends(MoveEntriesDialogComponent, _super);
    function MoveEntriesDialogComponent(dialogRef, store, actions) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.store = store;
        _this.actions = actions;
        _this.selectedFolder = ROOT_FOLDER;
        return _this;
    }
    MoveEntriesDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        var failure = this.actions.pipe(ofAction(MoveEntriesFailed)).subscribe(function () {
            _this.loading.next(false);
        });
        var success = this.actions.pipe(ofAction(MoveEntriesSuccess), take(1))
            .subscribe(function () {
            _this.selectedFolder = null;
            _this.close();
        });
        this.addSubs(success, failure);
    };
    MoveEntriesDialogComponent.prototype.confirm = function () {
        var _this = this;
        this.loading.next(true);
        this.store.dispatch(new MoveEntries(this.selectedFolder))
            .subscribe(function () {
            _this.loading.next(false);
        });
    };
    MoveEntriesDialogComponent.prototype.getRootFolder = function () {
        return ROOT_FOLDER;
    };
    MoveEntriesDialogComponent.prototype.canMove = function () {
        var folder = this.selectedFolder, movingEntries = this.store.selectSnapshot(DriveState.selectedEntries);
        return DriveState.canMoveEntriesTo(movingEntries, folder);
        if (!folder)
            return false;
        // should not be able to move folder into it's
        // own child or same folder it's already in
        return movingEntries.findIndex(function (entry) {
            var movingEntryIntoOwnChild = folder.path.startsWith(entry.path), movingEntryIntoSameFolder = entry.parent_id === (folder.id === 'root' ? null : folder.id);
            return movingEntryIntoOwnChild || movingEntryIntoSameFolder;
        }) === -1;
    };
    __decorate([
        Select(DriveState.selectedEntries),
        __metadata("design:type", Observable)
    ], MoveEntriesDialogComponent.prototype, "selectedEntries$", void 0);
    return MoveEntriesDialogComponent;
}(BaseDialog));
export { MoveEntriesDialogComponent };
